export const sendWhatsAppMessage = (phone, message) => {
  const formattedPhone = phone.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
  window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
};

export const createOrderMessage = (orderData, products) => {
  const siteUrl = window.location.origin;
  
  let message = `🛒 *NOUVELLE COMMANDE*\n\n`;
  message += `👤 *Client:* ${orderData.recipient_name}\n`;
  message += `📍 *Ville:* ${orderData.recipient_city}\n`;
  message += `🏘️ *Pays:* ${orderData.recipient_country}\n`;
  message += `📌 *Adresse:* ${orderData.recipient_address}\n`;
  message += `📱 *Téléphone:* ${orderData.recipient_phone}\n\n`;
  message += `📦 *Produits commandés:*\n`;
  
  products.forEach((item, index) => {
    const price = item.price || 0;
    const quantity = item.quantity || 1;
    message += `${index + 1}. ${item.name} x${quantity} - ${(price * quantity).toLocaleString('fr-FR')} FCFA\n`;
  });

  message += `\n💰 *Total:* ${(orderData.total_amount || 0).toLocaleString('fr-FR')} FCFA\n\n`;
  message += `🔗 *Lien de la commande:*\n${siteUrl}/product/${products[0]._id}\n\n`;
  message += `📊 *Voir toutes les commandes:*\n${siteUrl}/dashboard/orders`;
  
  return message;
};

export const createProductMessage = (product) => {
  const siteUrl = window.location.origin;
  const productUrl = `${siteUrl}/product/${product._id}`;
  
  let message = `👋 Bonjour,\n\n`;
  message += `Je suis intéressé(e) par ce produit:\n\n`;
  message += `📦 *${product.name}*\n`;
  message += `💰 Prix: ${product.price.toLocaleString()} FCFA\n`;
  message += `📂 Catégorie: ${product.category}\n\n`;
  message += `🔗 Lien du produit:\n${productUrl}\n\n`;
  message += `Pourriez-vous me donner plus d'informations?\n\n`;
  message += `Merci! 😊`;
  
  return message;
};